module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step05_8a48399421f1b11cfc4b40ea89cd8def.png";